import axios from 'axios';

const httpClient = axios.create({
    baseURL: process.env.SERVER_API,
});

export default httpClient;
